(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lashe-featured-slider"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.lashe-fs');

    sections.forEach(section => {
      const slides = section.querySelectorAll('[data-lashe-slide]');
      const panels = section.querySelectorAll('[data-lashe-panel]');
      const counter = section.querySelector('[data-lashe-current]');

      function goTo(index) {
        slides.forEach(s => s.classList.toggle('is-active', parseInt(s.dataset.lasheSlide) === index));
        panels.forEach(p => p.classList.toggle('is-active', parseInt(p.dataset.lashePanel) === index));

        if (counter) {
          counter.textContent = String(index + 1).padStart(2, '0');
        }

        section.querySelectorAll('.lashe-fs__panel.is-active [data-lashe-go]').forEach(btn => {
          btn.classList.toggle('is-active', parseInt(btn.dataset.lasheGo) === index);
        });
      }

      section.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-lashe-go]');
        if (!btn) return;
        goTo(parseInt(btn.dataset.lasheGo));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
